import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { useContext, useEffect, useMemo } from 'react';
import Prism from 'prismjs';
import { EditorContext } from '../../Context';
import "./index.css";
export default function Markdown(props) {
  var prefixCls = props.prefixCls,
    other = _objectWithoutProperties(props, ["prefixCls"]);
  var _useContext = useContext(EditorContext),
    markdown = _useContext.markdown,
    highlightEnable = _useContext.highlightEnable,
    dispatch = _useContext.dispatch;
  var preRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    if (preRef.current && dispatch) {
      dispatch({
        textareaPre: preRef.current
      });
    }
  }, []);
  var highlight = function highlight() {
    if (!preRef.current) return;
    if (highlightEnable) {
      var html = Prism.highlight(markdown, Prism.languages.markdown, 'markdown');
      preRef.current.innerHTML = "".concat(html);
    } else {
      preRef.current.innerText = "".concat(markdown);
    }
  };
  useEffect(function () {
    highlight();
  }, [markdown, preRef.current, highlightEnable]);
  return useMemo(function () {
    return /*#__PURE__*/React.createElement("pre", _extends({}, other, {
      ref: preRef,
      className: "".concat(prefixCls, "-text-pre wmde-markdown-color")
    }));
  }, [other, preRef, prefixCls]);
}